import noop from 'lodash/noop';
import React from 'react';
import APLFilters from '../APLFilters/APLFilters';
import APLFiltersMobile from '../APLFiltersMobile/APLFiltersMobile';
import Button from '../Buttons/Button/Button';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';
import S from './APLFilteredListing.styles';
function FilteredListing({ buttonThemeOption = 'aplGreen', error, errorText, filtersProps, flush = 'top', items, listTitle, loading = false, pageIndex = 0, renderItems, totalItems = 0, onPageChange = noop, }) {
    return (React.createElement(S.Container, { flush: flush },
        listTitle && React.createElement(S.ListTitle, null, listTitle),
        filtersProps && React.createElement(APLFilters, { ...filtersProps }),
        filtersProps && React.createElement(APLFiltersMobile, { ...filtersProps }),
        loading && renderLoading(),
        error && renderError(error),
        items && renderResults(items)));
    function renderError(error) {
        return React.createElement(S.Message, null, error.message);
    }
    function renderLoading() {
        return React.createElement(LoadingOverlay, null);
    }
    function renderResults(items) {
        if (items.length === 0) {
            return React.createElement(S.Message, null, errorText);
        }
        return (React.createElement(React.Fragment, null,
            renderItems(items),
            items.length < totalItems && (React.createElement(S.CtaWrapper, null,
                React.createElement(Button, { themeOption: buttonThemeOption, title: "Load More", onClick: (event) => {
                        event.preventDefault();
                        onPageChange(pageIndex + 1);
                    } })))));
    }
}
export default FilteredListing;
